import { styled } from '@clickcease/cc-client-components-lib'

export const PlatformConnectionModalStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '455px',
  height: '168px',
  padding: '$8 $12',
})

export const PlatformConnectionModalDescription = styled('div', {
  fontSize: '$md',
  fontWeight: '$l',
  marginBottom: '$9',
})
